/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Gamepad = (props: IconProps) => (
  <Icon {...props}>
    <path d="M21.97,15.94l-1.07-7.5C20.62,6.46,18.93,5,16.93,5H7.06c-2,0-3.69,1.46-3.97,3.44l-1.07,7.49 C1.81,17.48,2.95,18.99,4.52,19c0.68,0,1.33-0.27,1.81-0.75L8.6,16h6.8l2.25,2.25c0.84,0.84,2.2,1.04,3.27,0.28 C21.74,17.95,22.11,16.92,21.97,15.94z M10.25,11.25h-1v1C9.25,12.66,8.91,13,8.5,13h0c-0.41,0-0.75-0.34-0.75-0.75v-1h-1 C6.34,11.25,6,10.91,6,10.5v0c0-0.41,0.34-0.75,0.75-0.75h1v-1C7.75,8.34,8.09,8,8.5,8h0c0.41,0,0.75,0.34,0.75,0.75v1h1 c0.41,0,0.75,0.34,0.75,0.75v0C11,10.91,10.66,11.25,10.25,11.25z M15,10c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S15.55,10,15,10 z M17,13c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S17.55,13,17,13z" />
  </Icon>
);
